"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function FeaturedCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="54935" className="w-full overflow-hidden">
        <div className="flex gap-4 px-4 md:grid md:grid-cols-4 md:gap-0 md:px-0">
          {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="aspect-square w-[85vw] shrink-0 animate-pulse bg-secondary md:w-auto" />)}
        </div>
      </div>;
  }
  if (error || terms.length === 0) {
    return null;
  }
  return <div className="w-full">
      <div className="scrollbar-hide flex w-full gap-4 overflow-x-auto px-4 pb-4 md:grid md:grid-cols-4 md:gap-0 md:overflow-visible md:px-0 md:pb-0">
        {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} className="group relative block aspect-square w-[85vw] shrink-0 overflow-hidden border-transparent md:w-auto" data-index={i}>
            {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
                <span className="text-xs uppercase tracking-widest font-sans">Image Pending</span>
              </div>}

            <div className="absolute inset-0 bg-black/20 transition-opacity duration-500 group-hover:bg-black/40" />

            <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <div className="flex h-12 w-12 items-center justify-center rounded-none bg-white/10 backdrop-blur-md transition-all duration-500 group-hover:bg-white/30">
                <ArrowRight className="h-5 w-5 text-white" />
              </div>
            </div>

            <div className="absolute inset-x-0 bottom-0 top-0 flex items-center justify-center z-10 p-6 text-center">
              <h3 className="text-2xl font-serif text-white tracking-tight drop-shadow-sm">
                {term.name}
              </h3>
            </div>
          </Link>)}
      </div>
    </div>;
}
export default function FeaturedProductCategories() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 4,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="core-cosmetic-categories" className="bg-white py-16 md:py-32">
      <div className="container mx-auto mb-12 px-4 md:mb-20 text-center">
        <h2 className="text-4xl font-serif tracking-tight text-primary md:text-5xl">
          Our Core Collections
        </h2>
        <div className="mt-4 h-px w-24 bg-accent/30 mx-auto" />
      </div>
      
      <div className="container mx-auto">
        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <FeaturedCategoriesConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}